import React from "react";

const WhatsAppWidget = () => {
  const phoneNumber = "919876543210"; // include country code without +
  const message = "Hello! I need some help.";

  const handleClick = () => {
    const url = `https://wa.me/+917397664666?text=Hi,%20I%E2%80%99m%20interested%20in%20PRADCO%C2%AE%20products`;
    window.open(url, "_blank");
  };

  return (
    <div style={styles.container} onClick={handleClick}>
      <img
        src="https://cdn-icons-png.flaticon.com/512/733/733585.png"
        alt="WhatsApp"
        style={styles.icon}
      />
    </div>
  );
};

const styles = {
  container: {
    position: "fixed",
    bottom: "20px",
    right: "20px",
    width: "60px",
    height: "60px",
    backgroundColor: "#25D366",
    borderRadius: "50%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    cursor: "pointer",
    boxShadow: "0 4px 10px rgba(0,0,0,0.3)",
    zIndex: 1000,
  },
  icon: {
    width: "35px",
    height: "35px",
  },
};

export default WhatsAppWidget;